export class SchemaScript {
  query: string;
  create: string;
  change: string;
  delete: string;
  update: string;

}
